import { Home } from '../pages/home';
import { Profile } from '../pages/user/Profile';
import { ArticleList } from '../pages/article_list/Index';
import { ArticleDetail } from '../pages/article_list/ArticleDetail';
import { Project } from '../pages/project/Index';
import { ProjectDetail } from '../pages/project/ProjectDetail';
import { CreateProject } from '../pages/project/Create';
import { EditProject } from '../pages/project/Edit';
import { User } from '../pages/user/Index';
import { UserDetail } from '../pages/user/UserDetail';
import { EditUserDetail } from '../pages/user/Edit';

import { Route } from '../types/route';

export const protectedRoutes: Route[] = [
  {
    key: 'router-dashboard',
    title: 'Dashboard',
    description: 'Dashboard',
    component: Home,
    path: '/',
    isEnabled: true,
    appendDivider: true,
  },
  {
    key: 'router-profile',
    title: 'Profile',
    description: 'Profile',
    component: Profile,
    path: '/profile',
    isEnabled: true,
    appendDivider: true
  },
  {
    key: 'router-article-list',
    title: 'Article List',
    description: 'Article List',
    component: ArticleList,
    path: '/article-list',
    isEnabled: true,
    appendDivider: true
  },
  {
    key: 'router-article-detail',
    title: 'Article Detail',
    description: 'Article Detail',
    component: ArticleDetail,
    path: '/article-detail/:id',
    isEnabled: true,
    appendDivider: true
  },
  {
    key: 'router-project',
    title: 'Project',
    description: 'Project',
    component: Project,
    path: '/project',
    isEnabled: true,
    appendDivider: true
  },
  {
    key: 'router-project-detail',
    title: 'Project Detail',
    description: 'Project Detail',
    component: ProjectDetail,
    path: '/project-detail/:id',
    isEnabled: true,
    appendDivider: true
  },
  {
    key: 'router-create-project',
    title: 'Create Project',
    description: 'Create Project',
    component: CreateProject,
    path: '/create-project',
    isEnabled: true,
    appendDivider: true
  },
  {
    key: 'router-edit-project',
    title: 'Edit Project',
    description: 'Edit Project',
    component: EditProject,
    path: '/edit-project/:id',
    isEnabled: true,
    appendDivider: true
  },
  {
    key: 'router-user',
    title: 'User',
    description: 'User',
    component: User,
    path: '/user',
    isEnabled: true,
    appendDivider: true
  },
  {
    key: 'router-user-detail',
    title: 'User Detail',
    description: 'User Detail',
    component: UserDetail,
    path: '/user-detail/:id',
    isEnabled: true,
    appendDivider: true
  },
  {
    key: 'router-user-detail/:id/edit',
    title: 'Edit User Detail',
    description: 'Edit User Detail',
    component: EditUserDetail,
    path: '/user-detail/:id/edit',
    isEnabled: true,
    appendDivider: true
  },
];
